import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import layoutLogin from '../views/layout/Login.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    meta: {
      title: "去找屋"
    },
    component: layoutLogin,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home
      },
      {
        path: "/login",
        name: "Login",
        meta: {
          requireAuth: true,
          title: "系统登陆"
        },
        component: () => import("../views/Login.vue")
      },
      {
        path: "/WeChat",
        name: "WeChatLogin",
        meta: {
          title: "微信开放社区"
        },
        component: () => import("../views/WeChat/Login.vue")
      },
      {
        path: "/DongSen",
        name: "DongSen",
        meta: {
          title: "动物森友会图鉴"
        },
        component: () => import("../views/DongSen.vue")
      },
    ]
  },
  {
    path: "/Token",
    name: "Token",
    meta: {
      title: "公众号授权"
    },
    component: () => import("../views/Token.vue")
  },
  {
    path: '*',
    name: '404',
    redirect: () => {
      return "/"
    }
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
